import EntityId from '../domain/EntityId';
import Entity from '../domain/Entity';
import ApiData from './ApiData';
import ObjectDoesNotExistError from './ObjectDoesNotExistError';

abstract class Repository<T extends Entity<T>> {

	private objects: T[] = [];

	// public map (data: D): T;
	// public map (data: D[]): T[];
	//
	// public map (data: D|D[]) {
	//     return Array.isArray(data) ? this.mapList(data) : this.mapOne(data);
	// }

	public mapList (data: Object[]): T[] {
		return data.map(objectData => this.mapOne(objectData));
	}

	public mapOne (data: Object): T {
		const apiData = new ApiData(data);
		const newObject = this.mapObject(apiData);

		const equalObjectIndex = this.objects.findIndex(object => object.idEquals(newObject));

		if (equalObjectIndex === -1) {
			this.objects.push(newObject);

		} else {
			this.objects.splice(equalObjectIndex, 1, newObject);
		}

		return newObject;
	}

	public getByIdValue (idValue: number | string | null | undefined) {
		return this.getById(new EntityId<T>(idValue === null || idValue === undefined ? null : Number(idValue)));
	}

	public getOneOrUndefinedByIdValue (idValue: number | string | null | undefined) {
		return this.getOneOrUndefinedById(new EntityId<T>(idValue === null || idValue === undefined ? null : Number(idValue)));
	}

	public getById (id: EntityId<T>) {
		const object = this.objects.find(repositoryObject => repositoryObject.getId().equals(id));

		if (object === undefined) {
			throw new ObjectDoesNotExistError('The object you requested from the repository does not exist.');
		}

		return object;
	}

	public getOneOrUndefinedById (id: EntityId<T>) {
		try {
			return this.getById(id);

		} catch (error) {
			if (error instanceof ObjectDoesNotExistError) {
				return undefined;
			}

			throw error;
		}
	}

	public getAll () {
		return this.objects;
	}

	public flush () {
		this.objects = [];
	}

	protected abstract mapObject (data: ApiData): T;
}

export default Repository;


// WEBPACK FOOTER //
// ./code/foundation/repository/Repository.ts